import { TrackDatas } from '../types';

export const TRACKDATAS: TrackDatas = [
  // {
  //   title: 'short dev song 1',
  //   ACOUSTIC: { path: 'short-dev-song.wav' },
  //   COMMENTARY: { path: 'short-dev-song.wav' },
  //   SYNTHETIC: { path: 'short-dev-song.wav' },
  // },
  // {
  //   title: 'short dev song 2',
  //   ACOUSTIC: { path: 'short-dev-song2.wav' },
  //   COMMENTARY: { path: 'short-dev-song2.wav' },
  //   SYNTHETIC: { path: 'short-dev-song2.wav' },
  // },
  // {
  //   title: 'short dev song 3',
  //   ACOUSTIC: { path: 'short-dev-song3.wav' },
  //   COMMENTARY: { path: 'short-dev-song3.wav' },
  //   SYNTHETIC: { path: 'short-dev-song3.wav' },
  // },
  // {
  //   title: '1. Arrows',
  //   ACOUSTIC: { path: '1ArrowsAcoustic.mp3' },
  //   COMMENTARY: { path: '1ArrowsAcousticCommentary.mp3' },
  //   SYNTHETIC: { path: '1ArrowsSynthetic.mp3' },
  // },
  // {
  //   title: '2. The One',
  //   ACOUSTIC: { path: '2TheOneAcoustic.mp3' },
  //   COMMENTARY: { path: '2TheOneAcousticCommentary.mp3' },
  //   SYNTHETIC: { path: '2TheOneSynthetic.mp3' },
  // },
  // {
  //   title: '3. Interlude B',
  //   ACOUSTIC: { path: '3InterludeBAcoustic.mp3' },
  //   COMMENTARY: { path: '3InterludeBAcousticCommentary.mp3' },
  //   SYNTHETIC: { path: '3InterludeBSynthetic.mp3' },
  // },
  // {
  //   title: '4. Clear Of Night',
  //   ACOUSTIC: { path: '4ClearOfNightAcoustic.mp3' },
  //   COMMENTARY: { path: '4ClearOfNightAcoustic.mp3' },
  //   SYNTHETIC: { path: '4ClearOfNightSynthetic.mp3' },
  // },
  {
    title: '1. Unresolved',
    ACOUSTIC: { path: 'Quiet01.mp3' },
    COMMENTARY: { path: 'Liner01.mp3' },
    SYNTHETIC: { path: 'Violet01.mp3' },
  },
  {
    title: '2. Arrows',
    ACOUSTIC: { path: 'Quiet02.mp3' },
    COMMENTARY: { path: 'Liner02.mp3' },
    SYNTHETIC: { path: 'Violet02.mp3' },
  },
  {
    title: '3. Clean Lines',
    ACOUSTIC: { path: 'Quiet03.mp3' },
    COMMENTARY: { path: 'Liner03.mp3' },
    SYNTHETIC: { path: 'Violet03.mp3' },
  },
  {
    title: '4. Song For A Mentor',
    ACOUSTIC: { path: 'Quiet04.mp3' },
    COMMENTARY: { path: 'Liner04.mp3' },
    SYNTHETIC: { path: 'Violet04.mp3' },
  },
  {
    title: '5. Signaling Virtue',
    ACOUSTIC: { path: 'Quiet05.mp3' },
    COMMENTARY: { path: 'Liner05.mp3' },
    SYNTHETIC: { path: 'Violet05.mp3' },
  },
  {
    title: '6. The One',
    ACOUSTIC: { path: 'Quiet06.mp3' },
    COMMENTARY: { path: 'Liner06.mp3' },
    SYNTHETIC: { path: 'Violet06.mp3' },
  },
  {
    title: '7. Later',
    ACOUSTIC: { path: 'Quiet07.mp3' },
    COMMENTARY: { path: 'Liner07.mp3' },
    SYNTHETIC: { path: 'Violet07.mp3' },
  },
  {
    title: '8. Song For Byron',
    ACOUSTIC: { path: 'Quiet08.mp3' },
    COMMENTARY: { path: 'Liner08.mp3' },
    SYNTHETIC: { path: 'Violet08.mp3' },
  },
  {
    title: '9. Solo For Byron',
    ACOUSTIC: { path: 'Quiet09.mp3' },
    COMMENTARY: { path: 'Liner09.mp3' },
    SYNTHETIC: { path: 'Violet09.mp3' },
  },
  {
    title: '10. The Clear Of Night',
    ACOUSTIC: { path: 'Quiet10.mp3' },
    COMMENTARY: { path: 'Liner10.mp3' },
    SYNTHETIC: { path: 'Violet10.mp3' },
  },
];
